import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ApiAmenaService} from 'src/app/amena/services/api-amena.service';
import {ShoppingCartService} from 'src/app/amena/services/shopping-cart-service';
import {AlertDialogComponent} from '../../../../shared/components/alert-dialog/alert-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-pre-activation',
    templateUrl: './pre-activation.component.html',
    styleUrls: ['./pre-activation.component.css', '../../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class PreActivationComponent implements OnInit {
    @Output() activationStarted = new EventEmitter<boolean>();
    @Input('textDefault') textDefault: string;
    @Input('isLoading') isLoading: boolean;
    public form;
    public pdv;
    ariaExpanded = true;
    showCollapse = false;

    constructor(
        private matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private amenaService: ApiAmenaService,
        private shoppingCartService: ShoppingCartService
    ) {
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            commercial_communications: [false],
            third_party_commercial_communications: [false],
            orange_companies_data_transfer: [false],
            data_treatment: [false],
            third_party_data_transfer: [false],
            campaign_code: [null],
        });
        this.amenaService.getPDV().subscribe(data => {
            if (data != null) {
                console.log('PDV', data);
                this.pdv = data;
                this.updateValidators();
            }
        });
    }

    updateValidators() {
        if (this.pdv.info.telesales === 1) {
            this.form.get('campaign_code').setValidators([Validators.required, Validators.maxLength(5)]);
            this.form.get('campaign_code').updateValueAndValidity();
        }
    }

    activate() {
        if (this.pdv.permissions.SAMPLE_MODE && this.pdv.permissions.SAMPLE_MODE === 'SAMPLE') {
            this.matDialog.open(AlertDialogComponent, {
                data: {message: 'Usuario demostración. No se puede finalizar el alta'}
            });
        } else {
            this.form.markAllAsTouched();
            this.form.updateValueAndValidity();

            if (this.form.valid) {
                this.shoppingCartService.getShoppingCart().update(this.form);
                this.activationStarted.emit(true);
            }
        }
    }

    public errorHandling = (control: string, error: string) => {
        if (this.form.get(control).invalid && (this.form.get(control).dirty || this.form.get(control).touched)) {
            return this.form.controls[control].hasError(error);
        }
    };
}
